import { Modal } from 'react-bootstrap';
import moment from 'moment';

const ProspectiveStudentDetailsModal = (props) => {

    return (
        <Modal show={props.show} onHide={props.handleClose} size='xl'>
            <Modal.Header closeButton>
                <Modal.Title>Prospective Student Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className="row">
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Franchise Name </dt>
                        <dd>{props?.data?.franchise_name ?? '---'}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Centre Name </dt>
                        <dd>{props?.data?.centre_name ?? '---'}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>School Name </dt>
                        <dd>{props?.data?.school_name ?? '---'}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Subject  </dt>
                        <dd>{props?.data?.subject_name ?? '---'}</dd>
                    </div>
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Student Name </dt>
                        <dd>{props?.data?.student_name}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>DOB </dt>
                        <dd>{props?.data?.date_of_birth ? moment(props?.data?.date_of_birth).format('DD/MM/YYYY') : '---'}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Gender </dt>
                        <dd>{props?.data?.gender ? props?.data?.gender.charAt(0).toUpperCase() + props?.data?.gender.slice(1) : '---'}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Grade </dt>
                        <dd>{props?.data?.grade_name ??  '---'}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Allergies </dt>
                        <dd>{props?.data?.allergies ??  '---'}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Medical Conditions </dt>
                        <dd>{props?.data?.medical_conditions ??  '---'}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Medication </dt>
                        <dd>{props?.data?.medication ??  '---'}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Media Consent </dt>
                        <dd>{props?.data?.media_consent ? 'Yes' : 'No'}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Emergency Contact Name </dt>
                        <dd>{props?.data?.emergency_contact_name ??  '---'}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Emergency Contact Phone </dt>
                        <dd>{props?.data?.emergency_contact_phone ??  '---'}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Emergency Contact Relation </dt>
                        <dd>{props?.data?.emergency_contact_relation ??  '---'}</dd>
                    </div>
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Parent Name </dt>
                        <dd>{props?.data?.parent_name}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Parent Email </dt>
                        <dd>{props?.data?.parent_email}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Parent Phone </dt>
                        <dd>{props?.data?.parent_phone}</dd>
                    </div>
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Enquiry Date</dt>
                        <dd>{ props?.data?.inquiry_date ? moment(props?.data?.inquiry_date).format('DD/MM/YYYY') : '---'} </dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Status</dt>
                        <dd><span className={`badge ${props?.data?.lead_inquiry_status_id == 7 ? 'bg-success' : 'bg-warning'}`}>{props?.data.status ?? '---'}</span></dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Last Updated At </dt>
                        <dd>{props?.data?.status_updated_date ? moment(props?.data?.status_updated_date).format('DD-MM-YYYY hh:mm A') : '---'}</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Recent Comment</dt>
                        <dd>{props?.data.recent_comment ?? '---'}</dd>
                    </div>
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Assessment Location</dt>
                        <dd>{ props?.data?.assessment_location ?? '---'} </dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>How They Got In Touch ? </dt>
                        <dd>{ props?.data?.got_in_touch_id != '7' ? props?.data?.got_in_touch : props?.data?.got_in_touch_other_text }</dd>
                    </div>
                </div>
                <div className="col-sm-3">
                    <div className="form-group">
                        <dt>Where Did You Find About Us ?</dt>
                        <dd>{ (props?.data?.found_us_id == '8' || props?.data?.found_us_id == '9') ? props?.data?.found_via_other_text : props?.data?.found_us_via }</dd>
                    </div>
                </div>
            </div>
            </Modal.Body>
            {/* <Modal.Footer>
                <Button className='btn btn-default' onClick={props.handleClose}>Close</Button>
            </Modal.Footer> */}
        </Modal>
  )
}

export default ProspectiveStudentDetailsModal;